import { css } from '@repo/pandacss/styled-system/css';
import { MonetizableEnum } from '@repo/supergraph/marketplace/enums';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { filterEntitiesByState } from '../utils/geo-data';
import { GeoRecapList } from './GeoRecapList';
import { RecapListItem } from './RecapListItem';

export type RecapListProps = {
  title: string;
  recapItems: {
    recapDescription?: string;
    marketplaceEntity: {
      id: string;
      name: string;
      reviewLink?: string;
      displayName?: string;
      monetizable?: MonetizableEnum;
      states?: StateAbbreviation[];
    };
  }[];
  state?: StateAbbreviation;
  HeadingComponent?: React.ElementType;
};

export function RecapListSection({
  title,
  recapItems,
  state,
  HeadingComponent = 'h3',
}: RecapListProps): React.JSX.Element {
  const geoTargetedRecap = state ? filterEntitiesByState(recapItems, state) : recapItems;

  return (
    <div id="recap-section" data-testid="recap-list-section">
      <p
        className={css({
          marginTop: '0',
          marginRight: '0',
          marginBottom: '0',
          marginLeft: '0',
        })}
      >
        To recap our selections...
      </p>
      <HeadingComponent
        id="recap"
        className={css({ textStyle: 'textLargeBold', fontWeight: 'bold' })}
      >
        {title}
      </HeadingComponent>
      <ul
        className={css({
          listStyleType: 'disc',
          paddingLeft: '4',
          paddingBlockStart: '0',
          paddingBlockEnd: '0',
        })}
      >
        {geoTargetedRecap.map(({ recapDescription, marketplaceEntity }) => {
          const { id, reviewLink, displayName } = marketplaceEntity;
          return (
            <RecapListItem
              key={id}
              recapDescription={recapDescription}
              reviewLink={reviewLink}
              displayName={displayName}
              id={id}
            />
          );
        })}
      </ul>
    </div>
  );
}

type RecapListWrapperProps = {
  isGeoTargeted: boolean;
} & RecapListProps;

export const RecapListWrapper: React.FC<RecapListWrapperProps> = ({ isGeoTargeted, ...props }) => {
  return isGeoTargeted ? <GeoRecapList {...props} /> : <RecapListSection {...props} />;
};
